module.exports = __webpack_public_path__ + "img/s7.27dc9f9c.png";